import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Carousel } from "react-bootstrap";
import logo from "../assets/images/Logo.jpeg";
import round_logo from "../assets/images/round_logo.png";
import banner from "../assets/images/banner.jpeg";
import banner2 from "../assets/images/banner2.jpeg";
import playstoreImg from "../assets/images/playstore.png";
import sunset from "../assets/images/marek.jpg";
import galaxy from "../assets/images/galaxy.jpg";
import city from "../assets/images/city.jpg";
import "../css/landingPage.css";

const storeUrl = "https://play.google.com/store/search?q=buyandwin&c=apps";
const collections = [
  {
    title: "Nature & landscapes",
    label: "A little closer to the extraordinary",
    image: sunset,
    alt: "Warm sunset over mountain silhouettes",
  },
  {
    title: "Beyond the ordinary",
    label: "Find a fresh perspective",
    image: galaxy,
    alt: "Colorful nebula surrounded by stars",
  },
  {
    title: "Places & perspectives",
    label: "Discover beauty in every detail",
    image: city,
    alt: "City photography preview",
  },
];
const Arrow = () => <span aria-hidden="true">↗</span>;

export default function LandingPage() {
  const [activeImage, setActiveImage] = useState(0);
  const scrollTo = (id) =>
    document
      .getElementById(id)
      ?.scrollIntoView({
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ? "auto"
          : "smooth",
      });
  return (
    <div className="bw-landing">
      <div className="bw-shell">
        <header className="bw-nav bw-glass">
          <Link to="/" className="bw-brand" aria-label="Buyandwin home">
            <img src={round_logo} alt="Buyandwin logo" loading="lazy" />
            <span>
              buy<span>&</span>win
            </span>
          </Link>
          <nav aria-label="Main navigation">
            <button onClick={() => scrollTo("bw-collections")}>Explore</button>
            <button onClick={() => scrollTo("bw-how")}>How it works</button>
            <a href="mailto:support@buyandwin.in">Contact</a>
          </nav>
          <a
            className="bw-button bw-button-small"
            href={storeUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Get the app <Arrow />
          </a>
        </header>
        <main>
          <section className="bw-hero" aria-labelledby="bw-hero-title">
            <div className="bw-hero-copy">
              <div className="bw-eyebrow">
                <span className="bw-dot" /> A WORLD OF IMAGES. ONE APP.
              </div>
              <h1 id="bw-hero-title">
                Discover more.
                <br />
                Create something
                <br />
                <span>beautiful.</span>
              </h1>
              <p>
                Make room for a little inspiration. Discover beautiful photos
                and creative images at prices you’ll love, all in the Buyandwin
                app.
              </p>
              <div className="bw-hero-actions">
                <a
                  className="bw-button"
                  href={storeUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Discover the app <Arrow />
                </a>
                <button
                  className="bw-text-button"
                  onClick={() => scrollTo("bw-collections")}
                >
                  Explore collections <span aria-hidden="true">↓</span>
                </button>
              </div>
              <div className="bw-hero-notes">
                <span>✓ Secure UPI payments</span>
                <span>✓ Instant downloads</span>
              </div>
            </div>
            <div className="bw-showcase">
              <div className="bw-showcase-card bw-glass">
                <div className="bw-showcase-top">
                  <span>
                    <span className="bw-dot" /> YOUR NEXT INSPIRATION
                  </span>
                  <span aria-hidden="true">✧</span>
                </div>
                <div className="bw-feature-image">
                  <img
                    src={collections[activeImage].image}
                    alt={collections[activeImage].alt}
                  />
                  <div className="bw-image-caption">
                    <span>THE BEAUTY OF DISCOVERY</span>
                    <h2>{collections[activeImage].title}</h2>
                  </div>
                  <span className="bw-image-tag">Collection preview</span>
                </div>
                <div
                  className="bw-image-selector"
                  aria-label="Preview image collections"
                >
                  {collections.map((item, index) => (
                    <button
                      key={item.title}
                      className={index === activeImage ? "is-active" : ""}
                      onClick={() => setActiveImage(index)}
                      aria-label={`Preview ${item.title}`}
                      aria-pressed={index === activeImage}
                    >
                      <img src={item.image} alt="" />
                      <span>{["Nature", "Space", "Places"][index]}</span>
                    </button>
                  ))}
                </div>
              </div>
              {/* <div className="bw-floating-note bw-glass">
                <span aria-hidden="true">↓</span>
                <div>
                  <strong>Find it. Love it. Download it.</strong>
                  <small>Your next idea starts here.</small>
                </div>
              </div> */}
            </div>
          </section>
          <section
            className="bw-benefits bw-glass"
            aria-label="Shopping benefits"
          >
            {[
              ["✧", "Beautiful variety", "Nature, AI & Photoshop images"],
              ["↓", "Ready in a moment", "Download after your purchase"],
              ["✓", "Shop with confidence", "Secure & simple UPI payments"],
            ].map(([icon, title, detail]) => (
              <div key={title}>
                <span className="bw-benefit-icon" aria-hidden="true">
                  {icon}
                </span>
                <div>
                  <strong>{title}</strong>
                  <span>{detail}</span>
                </div>
              </div>
            ))}
          </section>
          <section
            id="bw-collections"
            className="bw-collections"
            aria-labelledby="bw-collections-title"
          >
            <div className="bw-section-heading">
              <div>
                <span className="bw-eyebrow">A LITTLE INSPIRATION</span>
                <h2 id="bw-collections-title">A world worth exploring.</h2>
              </div>
              <p>
                From everyday beauty to out-of-this-world perspectives.
                <br />
                Find images that speak to you.
              </p>
            </div>
            <div className="bw-collection-grid">
              {collections.map((item) => (
                <article className="bw-collection bw-glass" key={item.title}>
                  <div className="bw-collection-photo">
                    <img src={item.image} alt={item.alt} loading="lazy" />
                  </div>
                  <div className="bw-collection-info">
                    <div>
                      <h3>{item.title}</h3>
                      <p>{item.label}</p>
                    </div>
                    <a
                      href={storeUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Explore ${item.title} in the app`}
                    >
                      <Arrow />
                    </a>
                  </div>
                </article>
              ))}
            </div>
            <p className="bw-preview-label">
              A glimpse of our visual world. Explore available images in the
              app.
            </p>
          </section>
          <section
            id="bw-how"
            className="bw-how"
            aria-labelledby="bw-how-title"
          >
            <div>
              <span className="bw-eyebrow">LESS EFFORT. MORE INSPIRATION.</span>
              <h2 id="bw-how-title">
                From discovery
                <br />
                to download.
              </h2>
              <p>
                Great images, a simple shopping experience, and no minimum order
                value.
              </p>
              
            </div>
            <ol className="bw-steps bw-glass">
              <div className="bw-steps-header">
              <a
                className="bw-text-button"
                href={storeUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Find Buyandwin on Google Play <Arrow />
              </a>
              </div>
              {[
                [
                  "Find your favorite",
                  "Browse nature photos, AI generated images, and Photoshop creations in the app.",
                ],
                [
                  "Make it yours",
                  "Shop at affordable prices and pay easily with a secure UPI payment.",
                ],
                [
                  "Download & enjoy",
                  "Your images are ready to download immediately after payment.",
                ],
              ].map(([title, detail], i) => (
                <li key={title}>
                  <span>0{i + 1}</span>
                  <div>
                    <h3>{title}</h3>
                    <p>{detail}</p>
                  </div>
                </li>
              ))}
            </ol>
          </section>
          {/* <section className="bw-promo" aria-label="Buyandwin promotions">
            <Carousel interval={null}>
              <Carousel.Item>
                <img
                  src={banner}
                  alt="Buyandwin promotion with gift boxes and mobile phones"
                  loading="lazy"
                />
              </Carousel.Item>
              <Carousel.Item>
                <img
                  src={banner2}
                  alt="More from Buyandwin promotions"
                  loading="lazy"
                />
              </Carousel.Item>
            </Carousel>
          </section> */}
          <section
            className="bw-download bw-glass"
            aria-labelledby="bw-download-title"
          >
            <div>
              <span className="bw-eyebrow">TAKE INSPIRATION WITH YOU</span>
              <h2 id="bw-download-title">Your next discovery is a tap away.</h2>
              <p>Beautiful images. Easy payments. All in your pocket.</p>
            </div>
            <a
              href={storeUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Find Buyandwin on Google Play"
            >
              <img src={playstoreImg} alt="Get it on Google Play" />
            </a>
          </section>
        </main>
        <footer className="bw-footer">
          <div className="bw-footer-top">
            <div>
              <Link to="/" className="bw-brand">
                <span>
                  buy<span>&</span>win
                </span>
              </Link>
              <p>A little discovery. A lot of possibility.</p>
              <a href="mailto:support@buyandwin.in">support@buyandwin.in</a>
            </div>
            <div className="bw-footer-links">
              <span>THE DETAILS</span>
              <Link to="/privacyPolicy">Privacy Policy</Link>
              <Link to="/termsAndConditions">Terms and Conditions</Link>
            </div>
            <div className="bw-footer-links">
              <span>STAY CONNECTED</span>
              <a
                href="https://www.instagram.com/buyandwinwin/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram <Arrow />
              </a>
              <a
                href="https://www.facebook.com/buyandwin99"
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook <Arrow />
              </a>
              <a
                href="https://www.youtube.com/@buyandwin"
                target="_blank"
                rel="noopener noreferrer"
              >
                YouTube <Arrow />
              </a>
            </div>
          </div>
          <div className="bw-footer-bottom">
            <span>
              © {new Date().getFullYear()} BUYANDWIN All rights reserved.
            </span>
            <span>Made for the joy of discovery.</span>
          </div>
        </footer>
      </div>
    </div>
  );
}
